import Icon from '../components/Icon.vue'

Icon.register({
  'clipboard-list': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M336 64H256C256 28.7 227.3 0 192 0S128 28.7 128 64H48C21.5 64 0 85.5 0 112V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V112C384 85.5 362.5 64 336 64zM96 424C82.7 424 72 413.3 72 400S82.7 376 96 376 120 386.7 120 400 109.3 424 96 424zM96 328C82.7 328 72 317.3 72 304S82.7 280 96 280 120 290.7 120 304 109.3 328 96 328zM96 232C82.7 232 72 221.3 72 208S82.7 184 96 184 120 194.7 120 208 109.3 232 96 232zM192 40C205.3 40 216 50.7 216 64S205.3 88 192 88 168 77.3 168 64 178.7 40 192 40zM320 408C320 412.4 316.4 416 312 416H168C163.6 416 160 412.4 160 408V392C160 387.6 163.6 384 168 384H312C316.4 384 320 387.6 320 392V408zM320 312C320 316.4 316.4 320 312 320H168C163.6 320 160 316.4 160 312V296C160 291.6 163.6 288 168 288H312C316.4 288 320 291.6 320 296V312zM320 216C320 220.4 316.4 224 312 224H168C163.6 224 160 220.4 160 216V200C160 195.6 163.6 192 168 192H312C316.4 192 320 195.6 320 200V216z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/clipboard-list.js
// module id = VK6/
// module chunks = 144